import React, { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { db, auth } from "./lib/firebase";
import PublicSite from "./PublicSite";
import AdminDashboard, { AdminLogin } from "./admin/AdminDashboard";
import "./styles/global.css";

function getInitialTheme() {
  try { const s = localStorage.getItem("lt-theme"); if (s) return s; } catch (_) {}
  return "dark";
}

function getIsAdminRoute() {
  const hash = window.location.hash;
  return hash === "#/admin" || hash.startsWith("#/admin/");
}

export default function App() {
  const [adminRoute, setAdminRoute] = useState(getIsAdminRoute);
  const [user,       setUser]       = useState(undefined); // undefined = loading, null = signed out
  const [theme,      setTheme]      = useState(getInitialTheme);

  // Apply theme to <html>
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try { localStorage.setItem("lt-theme", theme); } catch (_) {}
  }, [theme]);

  // Listen to Firebase Auth state — persists across refreshes automatically
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setUser(u ?? null));
    return () => unsub();
  }, []);

  // React to hash changes
  useEffect(() => {
    const onHash = () => setAdminRoute(getIsAdminRoute());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  const onExit = () => {
    window.location.hash = "";
    setAdminRoute(false);
  };

  // Still checking auth state — render nothing (or a tiny loader)
  if (user === undefined) {
    return (
      <div style={{
        minHeight: "100vh", display: "flex",
        alignItems: "center", justifyContent: "center",
        background: "#080808"
      }}>
        <div style={{
          width: 36, height: 36, borderRadius: "50%",
          border: "3px solid rgba(255,255,255,0.15)",
          borderTopColor: "#C8102E",
          animation: "spin 0.7s linear infinite"
        }} />
      </div>
    );
  }

  return (
    <>
      {!adminRoute && (
        <PublicSite db={db} theme={theme} toggleTheme={toggleTheme} />
      )}
      {adminRoute && !user && (
        <AdminLogin auth={auth} />
      )}
      {adminRoute && user && (
        <AdminDashboard db={db} auth={auth} onExit={onExit} />
      )}
    </>
  );
}
